import { Flashbooks } from '@prisma/client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  invalidateFlashbookDesigns,
  updateFlashbook,
} from '../../services/flashbooks';
import { UpdateFlashbookPayload } from '../../types/flashbooks';

interface Options {
  onSuccess?: (result: Flashbooks) => void | Promise<void>;
  onError?: (error: unknown) => void | Promise<void>;
}

function useUpdateFlashbook({ onSuccess, onError }: Options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      flashbookId,
      payload,
    }: {
      flashbookId: string;
      payload: UpdateFlashbookPayload;
    }) => updateFlashbook({ flashbookId, payload }),
    onSuccess: async result => {
      await queryClient.invalidateQueries({
        queryKey: ['flashbook', 'business'],
      });
      if (
        result &&
        (result as UpdateFlashbookPayload).enableDirectBookings !== undefined
      ) {
        await invalidateFlashbookDesigns();
      }
      await onSuccess?.(result);
    },
    onError: async error => {
      await onError?.(error);
    },
  });
}

export default useUpdateFlashbook;
